export enum NotificationType {
  InspectionScheduled = 'InspectionScheduled',
  InspectionRejected = 'InspectionRejected',
  InspectionCancelled = 'InspectionCancelled',
  InspectionCompleted = 'InspectionCompleted',
  InspectionIssue = 'InspectionIssue',
  ReportSubmitted = 'ReportSubmitted',
  ReportApproved = 'ReportApproved',
  ReportRejected = 'ReportRejected',
  ExpenseSubmitted = 'ExpenseSubmitted',
  ExpenseApproved = 'ExpenseApproved',
  ExpenseRejected = 'ExpenseRejected',
  UserAssigned = 'UserAssigned',
  UserRemoved = 'UserRemoved',
  DocumentUploaded = 'DocumentUploaded',
  DocumentApproved = 'DocumentApproved',
  DocumentRejected = 'DocumentRejected',
  SystemAlert = 'SystemAlert',
  Custom = 'Custom',
  INFO = 'InspectionScheduled',
  SUCCESS = 'ReportApproved',
  WARNING = 'SystemAlert',
  ERROR = 'InspectionRejected',
  SYSTEM = 'SystemAlert',
}

export enum NotificationStatus {
  UNREAD = 'unread',
  READ = 'read',
}

export interface Notification {
  id: string;
  userId?: string; // ID do usuário destinatário da notificação
  title: string;
  message: string;
  type: NotificationType;
  status: NotificationStatus;
  createdAt: Date;
  priority?: string;
  category?: string;
  data?: Record<string, unknown> | string;
  actionUrl?: string;
}

export interface NotificationListResponse {
  notifications: Notification[];
  unreadCount: number;
  total: number;
}
